import de                 from "@/i18n/de";
import dms_de             from "@/i18n/dms_de";
import img_de             from "@/i18n/img_de";
import inb_de             from "@/i18n/inb_de";
import crm_de             from "@/i18n/crm_de";
import inc_common_de      from "@/i18n/inc_common_de";
import inc_todo_de        from "@/i18n/inc_todo_de";
import inc_clipboard_de   from "@/i18n/inc_clipboard_de";
import inc_invoice_de     from "@/i18n/inc_invoice_de";
import inc_repair_de      from "@/i18n/inc_repair_de";
import mail_de            from "@/i18n/mail_de";
import user_de            from "@/i18n/user_de";
import msd_common_de      from "@/i18n/msd_common_de";
import msd_contact_de     from "@/i18n/msd_contact_de";
import msd_contract_de    from "@/i18n/msd_contract_de";
import msd_disposition_de from "@/i18n/msd_disposition_de";
import msd_company_de     from "@/i18n/msd_company_de";
import msd_importer_de    from "@/i18n/msd_importer_de";
import msd_unit_de        from "@/i18n/msd_unit_de";
import msd_lgsmart_de     from "@/i18n/msd_lgsmart_de";
import msd_preferences_de from "@/i18n/msd_preferences_de";
import audit_de           from "@/i18n/audit_de";

const messages = {
    de: Object.assign({},
        de,
        dms_de,
        audit_de,
        img_de,
        inb_de,
        crm_de,
        inc_common_de,
        inc_todo_de,
        inc_clipboard_de,
        inc_invoice_de,
        inc_repair_de,
        mail_de,
        user_de,
        msd_common_de,
        msd_contact_de,
        msd_contract_de,
        msd_company_de,
        msd_importer_de,
        msd_unit_de,
        msd_lgsmart_de,
        msd_preferences_de,
        msd_disposition_de
    )};

export default {
    messages
}